import React from "react";
import BSModal from "react-bootstrap/Modal";

export default function Modal({
  show,
  modalId,
  title,
  body,
  modalSize,
  disableFooter,
  buttonText,
  action,
  buttonType,
  dismiss,
}) {
  return (
    <BSModal
      show={show}
      onHide={dismiss}
      id={modalId}
      size={modalSize == "large" ? "lg" : undefined}
    >
      <BSModal.Header closeButton>
        <BSModal.Title>{title}</BSModal.Title>
      </BSModal.Header>
      <BSModal.Body>{body}</BSModal.Body>
      {disableFooter ? null : (
        <BSModal.Footer>
          <button type="button" className={`btn btn-${buttonType ?? "primary"}`} onClick={action}>
            {buttonText}
          </button>
          <button type="button" className="btn bg-white border" onClick={dismiss}>
            Cancel
          </button>
        </BSModal.Footer>
      )}
    </BSModal>
  );
}
